/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

module.exports = reEscape;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/internal/reEscape.js
 ** module id = 56
 ** module chunks = 0
 **/